import { FC, c } from 'lib/component-utils'
import { setCookie } from 'nookies'
import { useRouter } from 'next/router'
import { useUserContext } from 'lib/context'

const LanguagePicker: FC = () => {
  const ctx = useUserContext()
  const router = useRouter()

  const setLanguage = (code: string) => {
    setCookie(null, 'lang', code, {
      maxAge: 365 * 24 * 60 * 60,
      path: '/',
    })
    router.reload()
  }

  const languageOptions = [
    { code: 'ru', name: 'Русский' },
    { code: 'en', name: 'English' },
    { code: 'zh', name: '中文' },
    { code: 'uz', name: "O'zbek" },
  ]

  return (
    <div className="flex flex-col">
      {languageOptions.map((option) => (
        <button
          key={option.code}
          className={c`group px-2 py-0.5 font-medium text-gray-700`}
          onClick={() => setLanguage(option.code)}
        >
          <div
            className={c`py-2.5 px-3 rounded-lg flex items-center gap-2.5 ${
              ctx.lang === option.code
            } bg-primary-100 group-hover:bg-primary-200 | group-hover:bg-gray-100`}
          >
            <span lang={option.code}>{option.name}</span>
          </div>
        </button>
      ))}
    </div>
  )
}

export default LanguagePicker
